<div class="modal-header"><h2 class="modal-title">Bulk Batch</h2></div>
<div class="modal-body">
  @if (contribution) {
    <div>
      <dx-form [formData]="contribution" validationGroup="validationGroup" [colCount]="2">
        <dxi-item
          dataField="accountId"
          [label]="{ text: 'Account' }"
          editorType="dxSelectBox"
          [editorOptions]="{ searchEnabled: true, items: otherAccounts, valueExpr: 'id', displayExpr: 'name' }"
        ></dxi-item>
        <dxi-item [label]="{ text: 'Giving Type' }">
          <div *dxTemplate>
            <dx-select-box
              [(value)]="contribution.givingTypeId"
              [dataSource]="types"
              valueExpr="id"
              displayExpr="name"
              [searchEnabled]="true"
              (onValueChanged)="givingTypeChanged($event)"
            ></dx-select-box>
          </div>
        </dxi-item>
        <dxi-item [label]="{ text: 'Box' }">
          <div *dxTemplate><dx-text-box #personSelect [(value)]="contribution.envelope" (onValueChanged)="envelopeChanged($event)"></dx-text-box></div>
        </dxi-item>
        <dxi-item
          #personSelect
          dataField="personId"
          [colSpan]="2"
          [label]="{ text: 'Person' }"
          editorType="dxSelectBox"
          [editorOptions]="{ items: people, valueExpr: 'id', displayExpr: 'name', searchEnabled: true, searchMode: 'contains', tabIndex: -1 }"
        ></dxi-item>
        <dxi-item dataField="amount" [editorOptions]="{ placeholder: '$0.00' }"></dxi-item>
        <dxi-item dataField="note" [editorOptions]="{ tabIndex: -1 }"></dxi-item>
        @if (checkNumberRequired) {
          <dxi-item dataField="checkNumber" [label]="'Check #'">
            <dxi-validation-rule [type]="'required'" [message]="'Required'"></dxi-validation-rule>
          </dxi-item>
        }
        <!-- <dxi-item itemType="empty"></dxi-item> -->
        <dxi-item itemType="empty"></dxi-item>
        <dxi-item itemType="empty"></dxi-item>
      </dx-form>
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        [dataSource]="contributions"
        [height]="500"
        [focusedRowEnabled]="false"
        [columnAutoWidth]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        >
        <dxi-column dataField="personName" dataType="text" caption="Box" width="150"></dxi-column>
        <dxi-column dataField="givingName" caption="Type" width="100"></dxi-column>
        <dxi-column dataField="amount" dataType="number" [format]="{ type: 'currency', precision: 2 }" width="150" cssClass="align-right-pad"></dxi-column>
        <dxi-column dataField="timeStamp" caption="Entered" dataType="date" width="150" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
        <dxi-column dataField="checkNumber" caption="Check #" width="150"></dxi-column>
        <dxo-selection [mode]="'single'"></dxo-selection>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <button class="btn btn-primary" (click)="add()" [disabled]="addProcessing || !contribution.personId">Add Contribution</button>
          <button class="ms-2 btn btn-danger" (click)="remove()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1" [tabIndex]="-1">Remove</button>
          <button class="ms-4 btn btn-sm btn-secondary" (click)="addBatchCash()" [tabIndex]="-1">Add Batch Cash</button>
        </div>
        <dxo-summary>
          <dxi-total-item column="amount" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 2 }" displayFormat="Sum: {0}"> </dxi-total-item>
        </dxo-summary>
      </dx-data-grid>
    </div>
  }
</div>
<div class="modal-footer">
  <button class="btn btn-success" (click)="save()" [disabled]="processing">Save</button>
  <button class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
